<div class="row">
  <div class="tab-wrapper planning-module-permissions col-12">
    <div class="d-flex mt-8 checkbox-wrapper">
      <app-checkbox
        id="canAccesPlanningModule"
        [isChecked]="hasAccessToObject(objectTypes.Risk) || isInPrimaryRole"
        [disabled]="isInPrimaryRole"
        (checked)="selectRiskUserRole($event)"
      ></app-checkbox>
      <span>{{ T.settings.employees_departments_org.manage_employee.can_access_risk_module | translate }}</span>
    </div>
    <div class="d-flex mt-8 mb-32 checkbox-wrapper">
      <app-checkbox
        id="canAccesPlanningModule"
        [isChecked]="hasAccessToObject(objectTypes.Risk_Assesment) || isInPrimaryRole"
        [disabled]="isInPrimaryRole"
        (checked)="selectRiskAssessmentUserRole($event)"
      ></app-checkbox>
      <span>{{
        T.common.can_acess_items | translate : { items: T.defaultLocalizations.risk_assessment.many | translate }
      }}</span>
    </div>
    <div class="projects-and-tasks" *ngIf="hasAccessToObject(objectTypes.Risk) || isInPrimaryRole">
      <div class="sub-section-label d-flex mt-16 mb-16">
        <span class="material-symbols-outlined">room</span>
        <span class="ms-8">{{ T.defaultLocalizations.risk.many | translate }}</span>
      </div>
      <div *ngIf="account.showRiskAndIssues" class="projects-and-tasks__role-permissions mt-8">
        <div class="permissions-selection row mb-24">
          <span class="col-4 text-left">{{
            T.settings.my_preferences.permissions.employee_roles.risk_manager | translate
          }}</span>
          <app-checkbox
            id="isRiskManager"
            class="col-3 d-flex"
            [isChecked]="!isInRole(employeeRoleTypes.General_User) || (isInRole(employeeRoleTypes.Risk_Manager) || isInPrimaryRole)"
            [disabled]="isInPrimaryRole"
            (checked)="selectedRiskManager($event)"
          ></app-checkbox>
          <app-button-transparent
            class="col-5 text-left"
            [app-tooltip]="{
              title: T.settings.my_preferences.permissions.employee_roles.risk_manager | translate,
              message: T.settings.my_preferences.permissions.risk_manager_tooltip | translate
            }"
            size="small"
            icon="error_outline"
            [text]="T.common.learn_more | translate"
            iconFontSize="16"
          ></app-button-transparent>
        </div>
      </div>
      <app-employee-permissions-section
        [employee]="employeeDetailsViewModel"
        [filterType]="filterTypes.Risk"
        [module]="moduleTypes.Risk"
        [isInPrimaryRole]="isInPrimaryRole"
        [isDepartmentSelected]="isDepartmentSelected"
        (permissionsChanged)="updateEmployeePermissions($event)"
      >
      </app-employee-permissions-section>
    </div>
    <div
      class="projects-and-tasks"
      *ngIf="account.useRiskAssesment && (hasAccessToObject(objectTypes.Risk_Assesment) || isInPrimaryRole)"
    >
      <div class="sub-section-label d-flex mt-32 mb-16">
        <span class="material-symbols-outlined">room</span>
        <span class="ms-8">{{ T.defaultLocalizations.risk_assessment.many | translate }}</span>
      </div>

      <app-employee-permissions-section
        [employee]="employeeDetailsViewModel"
        [filterType]="filterTypes.Risk_Assesment"
        [module]="moduleTypes.Risk"
        [isInPrimaryRole]="isInPrimaryRole"
        [isDepartmentSelected]="isDepartmentSelected"
        (permissionsChanged)="updateEmployeePermissions($event)"
      >
      </app-employee-permissions-section>
      <div class="projects-tasks-write-permissions mt-16">
        <div class="d-flex checkbox-wrapper">
          <app-checkbox
            id="canSeeConfidentialRAs"
            [isChecked]="canSeeConfidentialRAs() || isInPrimaryRole"
            [disabled]="isInPrimaryRole"
            (checked)="changeConfidentialRAAccess($event)"
          ></app-checkbox>
          <span>{{
            T.common.confidential_items | translate : { items: T.defaultLocalizations.risk_assessment.many | translate }
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
